import { render, staticRenderFns } from "./pointQuery.vue?vue&type=template&id=2ff70b84&scoped=true&"
import script from "./pointQuery.vue?vue&type=script&lang=js&"
export * from "./pointQuery.vue?vue&type=script&lang=js&"
import style0 from "./pointQuery.vue?vue&type=style&index=0&id=2ff70b84&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff70b84",
  null
  
)

export default component.exports